<template>
    <renderless-laravel-vue-pagination
        :data="data"
        :limit="limit"
        :show-disabled="showDisabled"
        :size="size"
        :align="align"
        v-on:pagination-change-page="onPaginationChangePage">

        <div class="pagging"
            :class="{
                'pagination-sm': size == 'small',
                'pagination-lg': size == 'large',
                'justify-content-center': align == 'center',
                'justify-content-end': align == 'right'
            }"
            v-if="computed.total > computed.perPage"
            slot-scope="{ data, limit, showDisabled, size, align, computed, prevButtonEvents, nextButtonEvents, pageButtonEvents }">

            <a href="" class="pagging__arrow" :class="{'_disabled': computed.currentPage == 1}" v-on="prevButtonEvents"> <!-- v-if="computed.prevPageUrl || showDisabled" :tabindex="!computed.prevPageUrl && -1" -->
                <svg>
                    <use href="/img/front/icons/svgmap.svg#arrow-left"></use>
                </svg>
            </a>

            <ul class="pagging__list">
                <li v-for="(page, key) in computed.pageRange" :key="key">
                    <a class="pagging__item" :class="{ '_active': page == computed.currentPage }" href="" v-on="pageButtonEvents(page)">
                        {{ page }}
                    </a>
                </li>
            </ul>

            <a href="" class="pagging__arrow" aria-label="Next" :class="{'_disabled': computed.currentPage == computed.lastPage}" v-on="nextButtonEvents"> <!-- v-if="computed.nextPageUrl || showDisabled" :tabindex="!computed.nextPageUrl && -1" -->
                <svg>
                    <use href="/img/front/icons/svgmap.svg#arrow-right"></use>
                </svg>
            </a>

        </div>

    </renderless-laravel-vue-pagination>
</template>

<script>
import RenderlessLaravelVuePagination from './RenderlessLaravelVuePagination.vue';

export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        limit: {
            type: Number,
            default: 0
        },
        showDisabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'default',
            validator: value => {
                return ['small', 'default', 'large'].indexOf(value) !== -1;
            }
        },
        align: {
            type: String,
            default: 'left',
            validator: value => {
                return ['left', 'center', 'right'].indexOf(value) !== -1;
            }
        }
    },

    methods: {
        onPaginationChangePage (page) {
            this.$emit('pagination-change-page', page);
        }
    },

    components: {
        RenderlessLaravelVuePagination
    }
}
</script>
